import { connect } from 'react-redux';

import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { GlobalState } from 'ha/types/store';

import SearchOverview from '../components/SearchOverview';
import {
  getPreviewNumberOfListings,
  getIsAdvertiserSearch,
  getIsSearchEmpty,
} from '../selectors';

export default connect((state: GlobalState) => ({
  isAuthenticated: getIsAuthenticated(state),
  previewNumberOfListings: getPreviewNumberOfListings(state),
  isAdvertiserSearch: getIsAdvertiserSearch(state),
  isSearchEmpty: getIsSearchEmpty(state),
}))(SearchOverview);
